/** Slug / edition heuristics for electoral Quebec apps (EQUE22 vs EQUE26). */

/** EQUE26 access slugs: eque26, quebec-2026, quebec2026, … */
export function slugLooksLikeEque26(slug?: string | null): boolean {
  if (!slug) return false
  const s = slug.trim().toLowerCase()
  if (s === 'eque26' || s.includes('eque26')) return true
  if (/quebec[-_]?2026/.test(s)) return true
  return false
}

/** Bundle i18n/quebec (EQUE22 + EQUE26), not Canada. */
export function slugLooksLikeQuebecElection(slug?: string | null): boolean {
  if (!slug) return false
  const s = slug.trim().toLowerCase()
  if (s === 'default' || s === 'quebec2022') return true
  if (slugLooksLikeEque26(s)) return true
  // Other quebec* access slugs (not canada / sante / usa)
  if (s.startsWith('quebec') || s.startsWith('eque')) return true
  return false
}
